export interface AddOrder {
  productId: number;
  productType: number;
  price: number;
  discount: number;
  isInstallment: boolean;
}
export enum OrderStatus {
  Pending,
  Inprogress,
  Success,
  Failed,
  Canceled,
}
export enum DiscountResult {
  HasUsedBefore = -1,
  UserCapacityFullfilled = -2,
  CapacityFullfilled = -3,
  HasNotStarted = -4,
  HasEnded = -5,
  HasWronged = -6,
}
export interface Bill {
  id: number;
  isInstallment: boolean;
  isCancel: boolean;
  isAdmin: boolean;
}
export enum DiscountType {
  Percent,
  Amount,
}
export enum GiftCodeStepsEnums {
  Default,
  HasInvitationCode,
  GiftCode,
  Result,
}
export interface PendingOrder {
  code: string;
  isEnable: boolean;
}
export interface UserAllCourseAndPackage {
  courseCount: number;
  packageCount: number;
  courses: any[];
  packages: any[];
  recommended: any[];
}
export interface OnlineCourse {
  courseTitle: string;
  guestLinkDescription?: string;
  title: string;
  sessionTitle: string;
  date: string;
  isActive: boolean;
  hour: number;
  id: number;
  sessionId: number;
  courseId: number;
}
